/**
 * Factor-vector normalisation with idiosyncratic residual (plan §3.3).
 * nrm = sqrt(Σf² + idio²) — isolated because the idio asymmetry is subtle.
 *
 * Invariant the idio term buys: callers passing `idio > 0` get `nrm > 0`, so it
 * is a safe divisor for cosine similarity. The function itself is total — a zero
 * factor vector with `idio === 0` returns 0 — so the guarantee lives with the
 * caller (deriveFactors draws idio from [IDIO_LO, IDIO_LO + IDIO_SPAN]), and
 * universe.test.ts asserts `nrm > 0` for every built security.
 */
export function factorNorm(factors: readonly number[], idio: number): number {
  const sumSq = factors.reduce((acc, x) => acc + x * x, 0);
  return Math.sqrt(sumSq + idio * idio);
}
